module.exports = __webpack_public_path__ + "img/img12.1c5551e6.jpg";